var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeskCalendar = function SvgDeskCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.25 4.25h15.5v11.5H2.25zm1.5 1.5v8.5h12.5v-8.5h-2.5V7.5h-1.5V5.75h-4.5V7.5h-1.5V5.75z",
    clipRule: "evenodd"
  })));
};
export { SvgDeskCalendar as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMi4yNSA0LjI1SDE3Ljc1VjE1Ljc1SDIuMjVWNC4yNVpNMy43NSA1Ljc1VjE0LjI1SDE2LjI1VjUuNzVIMTMuNzVWNy41SDEyLjI1VjUuNzVINy43NVY3LjVINi4yNVY1Ljc1SDMuNzVaIiAvPgo8L3N2Zz4K";